import graphqlClient from "../../../api/axios_interceptor";
import { fetchTenantUserQuery, fetchTenantPropertiesQuery, fetchTenantHistoryQuery } from "../../../api/graphql/tenantApp/queries/home";
import { GET_TENANT_USER_DETAILS, GET_TENANT_PROPERTIES, GET_TENANT_HISTORY } from "../actions/actionTypes";
import { updateActionErrors } from "../middleware/updateErrors";

export const fetchTenantUserMiddleware = async (action) => {
    try{
        const query = fetchTenantUserQuery();
        await graphqlClient({
            data: {
                query
            }
        }).then((queryResult) =>{
            if (queryResult.data.errors){
                action = updateActionErrors(action, queryResult.data.errors)
            }else{
                action.payload = {
                    ...action.payload,
                    ...queryResult.data.data.fetchTenantUser,
                }
            }
        })

    }catch (error){
        console.error(error)
        action = updateActionErrors(action, error)
    }
    return action
}

export const fetchTenantPropertiesMiddleware = async (action) => {
    try{
        const query = fetchTenantPropertiesQuery();
        await graphqlClient({
            data: {
                query
            }
        }).then((queryResult) =>{
            if (queryResult.data.errors){
                action = updateActionErrors(action, queryResult.data.errors)
            }else{
                action.payload = {
                    ...action.payload,
                    tenantProperty: queryResult.data.data.tenantProperty,
                }
            }
        })

    }catch (error){
        console.error(error)
        action = updateActionErrors(action, error)
    }
    return action;
}

export const fetchTenantHistoryMiddleware = async (action) => {
    try{
        const query = fetchTenantHistoryQuery(action.payload.tenantId);
        await graphqlClient({
            data: {
                query
            }
        }).then((queryResult) =>{
            if (queryResult.data.errors){
                action = updateActionErrors(action, queryResult.data.errors)
            }else{
                action.payload = {
                    ...action.payload,
                    tenantHistory: queryResult.data.data.tenantHistory,
                }
            }
        })
}catch (error){
    console.error(error)
    action = updateActionErrors(action, error)
}
return action;
}




export const tenantHomeMiddleware = storeAPI => next => async (action) => {
    switch (action.type) {
        case GET_TENANT_USER_DETAILS:
            action = await fetchTenantUserMiddleware(action)
            break;
        case GET_TENANT_PROPERTIES:
            action = await fetchTenantPropertiesMiddleware(action)
            break;
        case GET_TENANT_HISTORY:
            action = await fetchTenantHistoryMiddleware(action)
            let propertyDetails = storeAPI.getState().tenantProperties.find(
                (property) => 
                    property.tenantId === action.payload.tenantId
                )
            action.payload = {
                ...action.payload,
                propertyDetails: propertyDetails || []
            }
            break;
    }
    return next(action);
}